// app/providers.tsx
'use client'

import { ChakraProvider, extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
    components: {}
})

export function Providers({ children }) {
    return <ChakraProvider theme={theme}>{children}</ChakraProvider>
}